// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import AdvancedCreatePost from './advanced_create_post';

export default AdvancedCreatePost;
